<template lang="pug">
  .carousel-container.width-100
    .column.m4-bottom-5.m4-left-3
      .row.width-100.title-container.width-100.middle
        h3.title-medium.m4-bottom-1.m-right-auto
          | {{ title }}
        router-link.row.text-normal.blue.bold.middle(v-if='seeMoreLink' :to='seeMoreLink.url')
          | {{ seeMoreLink.text }}
      h5.text-normal.dark-gray(v-if='subtitle')
        | {{ subtitle }}
    .column(v-if='!loading')
      carousel.row.middle.center.width-100(
        :navigationEnabled='false'
        :perPage='perPage'
        :paginationEnabled='false'
        ref='carousel'
        @pageChange='getNextPage'
      )
        slot
      button.arrow-container.arrow-left(v-if='showPrevArrow' type='button' @click='prevSlide')
        simple-svg.arrow.dark-gray-hover-blue(:filepath='arrowLeft' :width='"20px"' :height='"20px"')
      button.arrow-container.arrow-right(v-if='showNextArrow' type='button' @click='nextSlide' :disabled='disableNextButton')
        simple-svg.arrow.dark-gray-hover-blue(:filepath='arrowRight' :width='"20px"' :height='"20px"')
    .relative.row.center(v-else)
      .card-grid.width-100(v-if='skeleton === "resource"')
        sk-resource-card.item-1(v-for='n in 4' :key='n')
      .card-grid.width-100(v-if='skeleton === "program"')
        sk-program-card.item-1(v-for='n in 4' :key='n')
      .animation-container.row.middle.center.m4-bottom-8.absolute
        loader(size='inner')
</template>

<script>
import SkResourceCard from '@/components/SkResourceCard'
import SkProgramCard from '@/components/SkProgramCard'
import Loader from '@/components/Loader'

import arrowLeft from '@/assets/ic_chevron-left.svg'
import arrowRight from '@/assets/ic_chevron-right.svg'

import { firstPage, nextPage, prevPage, pagesOffset } from '../utils/constants'

export default {
  data() {
    return {
      arrowLeft,
      arrowRight,
      currentPage: firstPage,
      disableNextButton: false
    }
  },
  methods: {
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage())
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage())
    },
    async getNextPage() {
      if (this.page === this.currentPage + pagesOffset && this.page !== this.totalPages) {
        this.disableNextButton = true
        await this.$emit('getNextPage', { pageNumber: this.page, pageSize: this.perPage })
        this.disableNextButton = false
      }
      this.currentPage += this.currentPage < this.$refs.carousel.currentPage ? nextPage : prevPage
    }
  },
  computed: {
    showPrevArrow() {
      return this.currentPage > firstPage
    },
    showNextArrow() {
      return this.currentPage < this.totalPages - 1
    }
  },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false },
    perPage: { type: Number, required: false, default: 4 },
    page: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    loading: { type: Boolean, required: false, default: false },
    seeMoreLink: { type: [Function, Object], required: false, default: null },
    ephemerideKimpleFolderId: { type: Number, required: false },
    skeleton: { type: String, default: 'resource' }
  },
  components: { SkResourceCard, Loader, SkProgramCard }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.carousel-container {
  max-width: $content-size;
  position: relative;
  width: 100%;
}

.arrow-container {
  bottom: 35%;
}

.arrow-left {
  left: -10px;
}

.arrow-right {
  right: -10px;
}

.animation-container {
  height: 290px;
  padding-right: 40px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
}

.title-container {
  padding-right: 20px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
</style>
